export const mapKey = 'LKkUn7boWnUU9gfp7UrIOj0Ei1cPTEBBJ8EiVZvXN1w';